/**
 * @file BuilderNotices.tsx
 * @description Полосы над канвой конструктора (phase19.16 Р1-6а;
 * uiux-builder-shell.md §3.1, §6): почему «Опубликовать» неактивна (текстом,
 * не только подсказкой — на касании её не видно), чьи правки вида ждут
 * публикации (SB79), видимость открытой страницы.
 * SB125: «Сайт работает без: … [Исправить →]», пока опубликованный сайт
 * живёт с незакрытыми проверками (`LiveChecksNotice`).
 * Р3а (SB126, SB128): «Страницу сейчас правит …» (`PageEditingNotice`);
 * «Страница ещё не была на сайте — покупатели её не видят»; у скрытой
 * страницы «Показать на сайте» — сразу, если правок нет, иначе окно
 * публикации с галочкой «показывать на сайте».
 */

import { Button } from "../ui/button";
import { NoticeStrip } from "../ui/NoticeStrip";
import { LiveChecksNotice } from "../site-view/LiveChecksNotice";
import { SiteDraftStrip } from "../site-view/SiteDraftStrip";
import { useSiteView } from "../site-view/site-view-context";
import { useBuilder } from "./builder-context";
import { PageEditingNotice } from "./publish/PageEditingNotice";
import { useBuilderMainAction } from "./top/useBuilderMainAction";
import { usePageVisibility } from "../../hooks/site-builder/usePageVisibility";

export function BuilderNotices() {
  const b = useBuilder();
  const view = useSiteView();
  const main = useBuilderMainAction();
  const visibility = usePageVisibility();
  const changes = b.selection.screen ? null : b.publishing.changes;
  const blocked = (view.changes?.blockedBy.length ?? 0) > 0;
  const reason = main.action.kind === "disabled" ? main.action.reason : null;

  // Пустая обёртка скрыта (`empty:hidden`): плашка SB125 сама решает, показываться ли.
  return (
    <div className="flex shrink-0 flex-col gap-2 empty:hidden">
      <LiveChecksNotice />
      {changes ? <PageEditingNotice draft={changes.draft} /> : null}
      {blocked ? <SiteDraftStrip /> : null}
      {reason ? <NoticeStrip tone="info">{reason}</NoticeStrip> : null}
      {changes && !changes.isPublished ? (
        <NoticeStrip
          tone="warning"
          action={
            b.canPublishPages && changes.kind !== "SLOT" ? (
              <Button variant="outline" loading={visibility.busy} onClick={() => void visibility.show()}>
                Показать на сайте
              </Button>
            ) : undefined
          }
        >
          {changes.live === null ? "Страница ещё не была на сайте — покупатели её не видят." : "Страница скрыта — покупатели её не видят."}
        </NoticeStrip>
      ) : null}
    </div>
  );
}
